import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: true,
  selector: '[afcuPhoneMask]'
})
export class PhoneMaskDirective {

  constructor(private el: ElementRef, private control: NgControl) { }

  @HostListener('input', ['$event'])

  onInputChange(event: any) {
    let newVal = event.target.value.replace(/\D/g, '');
    if (newVal.length === 0) {
      newVal = '';
    } else if (newVal.length <= 3) {
      newVal = `${newVal}`;
    } else if (newVal.length <= 6) {
      newVal = `${newVal.slice(0, 3)}-${newVal.slice(3, 6)}`;
    } else {
      newVal = `${newVal.slice(0, 3)}-${newVal.slice(3, 6)}-${newVal.slice(6, 10)}`;
    }
    this.control.control?.setValue(newVal, { emitEvent: false });
  }
}
